import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import { Category, categorySlugMap } from "../Category.js";
import { Locale, type LocalizedString } from "../Locale.js";
import { solutionsPathMap } from "./solutionsPathMap.js";
import type { Product } from "../Product.js";
import { getProductDetailPath } from "./getProductDetailPath.js";

export function getSolutionSubcategoryPath(category: Category, vertinodeAiProduct: Product): LocalizedString {
	return Object.values(Locale).reduce<LocalizedString>((acc, locale) => {
		acc[locale] =
			category === Category.VertinodeAi
				? getProductDetailPath(category, vertinodeAiProduct)
				: `${solutionsPathMap[locale]}/${categorySlugMap[category][locale]}`;
		return acc;
	}, sameValueForEveryLocale(""));
}
